import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import { Grid } from "@aws-amplify/ui-react";

import BlueLocationIcon from "../../static/images/blue-location.png";
import RedLocationIcon from "../../static/images/red-location.png";

const containerStyleMap = {
  width: "100%",
  height: "400px",
};

const centerMap = {
  lat: 6.25184,
  lng: -75.56359,
};

const CustomIcon = (color) => ({
  url: `data:image/svg+xml,<svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 0 24 24"
    width="24"
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path fill="${color}" d="M18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-5 0h-2v-2h2v2zm0-4h-2V8h2v4zm-1 10c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2z" />
  </svg>`,
  scaledSize: {
    width: 35,
    height: 35,
  },
});

const MonitorMap = ({ devices, selectedDevice, onSelectDevice }) => {
  const { isLoaded: mapIsLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  return (
    <Grid>
      {mapIsLoaded && (
        <GoogleMap
          mapContainerStyle={containerStyleMap}
          center={{
            lat: selectedDevice
              ? selectedDevice.coordsLat
              : devices[0]?.coordsLat
              ? devices[0]?.coordsLat
              : centerMap.lat,
            lng: selectedDevice
              ? selectedDevice.coordsLng
              : devices[0]?.coordsLng
              ? devices[0]?.coordsLng
              : centerMap.lng,
          }}
          zoom={15}
        >
          {devices
            ?.filter((dev) => dev.coordsLat !== null && dev.coordsLng !== null)
            ?.map((dev) => (
              <Marker
                icon={
                  dev.id === selectedDevice?.id
                    ? BlueLocationIcon
                    : dev.alerts?.length <= 0
                    ? RedLocationIcon
                    : CustomIcon(
                        encodeURIComponent(dev.alerts[0].severityColor)
                      )
                }
                zIndex={dev.id === selectedDevice?.id ? 9999 : undefined}
                position={{
                  lat: dev.coordsLat,
                  lng: dev.coordsLng,
                }}
                onClick={() => onSelectDevice(dev)}
              ></Marker>
            ))}
        </GoogleMap>
      )}
    </Grid>
  );
};

export default MonitorMap;
